// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"162":"01f34646","238":"abd95c42","787":"8bacb779"}[chunkId] + ".chunk.js";
};